import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import OrderTemplate from '@/views/ViewsComponents/orderMaintenance/OrderTemplate.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "订单类别维护" }, {
          default: _withCtx(() => [
            _createVNode(OrderTemplate, { categoryType: 'OrderCategory' })
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "成本类别维护",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(OrderTemplate, { categoryType: 'Cost' })
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "地域维护",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(OrderTemplate, { categoryType: 'Region' })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})